import {FC, useState} from 'react'
import TimeSelect from "../../Date/TimeSelect";
import {bookingCalendar} from "../../../constants/global";
import {TimeSlot} from "../../../types";
import LoanCar from "../../Date/LoanCar";
import Rental from "../../Date/Rental";
import RentalOpel from "../../Date/RentalOpel";
import {checkSpotsAvailability} from "../../../wordpress/operations/post-reservation";
import {resetDateCarousel} from "../../../lib/date-caroussel";

interface Props {
    calendar:any,
    booking:Booking,
    setBooking:Function,
    getMonth:Function,
    setPlainDate?:Function,
    content:Content
}

export type Month = Day[]
export type Day = {
    'class':string,
    'num':number,
    'slots':TimeSlot[]
}

const Calendar: FC<Props> = ({calendar, booking, setBooking, getMonth, setPlainDate, content}) => {
    const [spots, setSpots] = useState<any>([]);
    const days:any = ['Må', 'Ti', 'On', 'To', 'Fr', 'Lö','Sö']
    const months:any = {1:'Januari', 2:'Februari', 3:'Mars', 4:'April', 5:'Maj', 6:'Juni', 7:'Juli', 8:'Augusti', 9:'September', 10:'Oktober', 11:'November', 12:'December'}

    const handleHover = (num:number) => {
        const monthFlat:Month = calendar.month.flat()
        const day = monthFlat.find(obj => {
            return obj.num === num
        })

        const next_step = booking.calendar_carousel.steps[1]
        if(day.class.includes("car")){
            booking.calendar_carousel = resetDateCarousel('date next loan car', booking.calendar_carousel.index)
        }else{
            booking.calendar_carousel = resetDateCarousel('date next no loan car', booking.calendar_carousel.index)
        }
        booking.calendar_carousel.steps[1] = next_step

        setBooking({
            ...booking,
        })
    }

    const handleClick = (num:number) => {
        // Flatten month object and find clicked day
        const monthFlat:Month = calendar.month.flat()
        const day = monthFlat.find(obj => {
            return obj.num === num
        })

        if(!day.class.includes('free'))
            return

        for(let i=0; i<monthFlat.length; i++){
            let c = monthFlat[i].class
            if(monthFlat[i].class.includes("selected")) {
                c = 'free'
            }

            if(monthFlat[i].class.includes("car")) {
                c = 'free car'
            }

            if(monthFlat[i].class.includes("discount")) {
                c += ' discount'
            }

            monthFlat[i].class = c
        }
        day.class += ' selected'
        booking.dateHasLoanCar = day.class.includes("car") === true
        booking.isLastMinute = day.class.includes("discount") === true
        if(booking.isLastMinute) {
            booking.isLastMinuteMessage = calendar.discountMessage;
        }
        booking.submission.reload = true

        switch(day.slots[0].time) {
            case 'all day': // For wc bookings calendar
                booking.date = day.slots[0].date

                // Update date carousel steps
                booking.calendar_carousel.index++
                if(booking.dateHasLoanCar) {
                    booking.calendar_carousel = resetDateCarousel('date next loan car', booking.calendar_carousel.index)
                    if(booking.loan_car === 'yes' || booking.loan_car === 'no') {
                        booking.calendar_carousel.steps[2].active = true
                    }
                }else{
                    booking.calendar_carousel = resetDateCarousel('date next no loan car', booking.calendar_carousel.index)
                }
                break;
            case 'all day plain': // For window damage time
                setPlainDate(day.slots[0].date)
                // Update date carousel steps
                booking.calendar_carousel.index++
                if(booking.dateHasLoanCar) {
                    booking.calendar_carousel = resetDateCarousel('date next loan car', booking.calendar_carousel.index)
                    if(booking.loan_car === 'yes' || booking.loan_car === 'no') {
                        booking.calendar_carousel.steps[2].active = true
                    }
                }else{
                    booking.calendar_carousel = resetDateCarousel('date next no loan car', booking.calendar_carousel.index)
                }
                break;
            default: // For hjulskifte and chip repair (date with time slots)
                booking.date = day.slots[0].date
                booking.submission.name = 'Välj tid'
                booking.submission.time = null
                booking.hjulskifte.date = ''
                booking.hjulskifte.spot_id = null
                setSpots([]) // Reset time spots
                checkSpotsAvailability(day.slots, booking).then((val) => {
                    setSpots(val)
                })
        }

        setBooking({
            ...booking,
        })
    }

    const handleMonth = (num:number) => {
        let year = calendar.year
        if(num===1 && calendar.nav.month.current===12)
            year = calendar.year + 1

        if(num===12 && calendar.nav.month.current===1)
            year = calendar.year - 1

        getMonth(year + '-' + num + '-1')
    }

    if(!calendar)
        return <></>

    // Mark selected date
    const monthFlat:Month = calendar.month.flat()
    for(let i=0; i<monthFlat.length; i++){
        if(!monthFlat[i].slots)
            continue
        if(monthFlat[i].slots[0].date === booking.date)
            monthFlat[i].class += ' selected'
    }

    let showCarIcon = true
    if(booking.booking_flow === 'hjulskifte' || booking.booking_flow === 'window' && booking.window.form.window_damage_type === 'chip') {
        showCarIcon = false
    }

    // {months[calendar.nav.month.prev]}
    // {months[calendar.nav.month.next]}
    return (
        <>
            {booking.calendar_carousel.steps[booking.calendar_carousel.index].slug  === 'date' ? (
                <>
                    <div className="ts-calendar">
                        <nav className="month-nav">
                            <div className="prev-month change-month"
                                 onClick={() => handleMonth(calendar.nav.month.prev)}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
                                </svg>
                            </div>
                            <div className="current-month">{months[calendar.nav.month.current]} {calendar.year}</div>
                            <div className="next-month change-month"
                                 onClick={() => handleMonth(calendar.nav.month.next)}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
                                </svg>
                            </div>
                        </nav>
                        <div className="day-select">
                            <table cellPadding="0" cellSpacing="0">
                                <thead>
                                <tr>
                                    {days.map((day: string, i: number) => (
                                        <th key={i}>{day}</th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {calendar.month.map((day: any, i: number) => (
                                    <tr key={i}>
                                        {day.map((data: any, i: number) => (
                                            <td className={data.class} key={i} onClick={() => handleClick(data.num)}
                                                onMouseEnter={() => handleHover(data.num)}>{data.num > 0 ? data.num : ''}</td>
                                        ))}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div id={"calendar-end"}/>
                    {showCarIcon ? (
                        <div className={'car-icon'}>
                            <div className={'car-icon-icon'}/>
                            <span>Lånebil tillgänglig</span>
                        </div>
                    ) : ''}
                    {calendar.isDiscountCalendar && (
                        <div className={'calendar-discount'}>
                            <div className={'calendar-discount-icon'}/>
                            <span>{calendar.discountMessage}</span>
                        </div>
                    )}
                </>
            ) : ''}

            <TimeSelect booking={booking} setBooking={setBooking} slots={spots} content={content}/>

            {booking.calendar_carousel.steps[booking.calendar_carousel.index].slug === 'loan-car' ? (
                <>
                    {calendar.isLoanCarCalendar && (<LoanCar booking={booking} setBooking={setBooking} />)}
                    {booking.car.brand === 'Mercedes-Benz' && (<Rental booking={booking} setBooking={setBooking} />)}
                    {booking.car.brand === 'Opel' && (<RentalOpel booking={booking} setBooking={setBooking} />)}
                </>
                ):''}
        </>
    )
}

export default Calendar
